import axios from "axios";
import BASE_URL from "../../config";

const getAuthHeader = () => {
  const tokenData = JSON.parse(localStorage.getItem("authUser") || "{}");
  return {
    Authorization: `Bearer ${tokenData.accessToken}`,
    'Content-Type': 'application/json'
  };
};

export const getTaxes = async (filter = {}) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/Tax/get`, filter, {
      headers: getAuthHeader(),
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching taxes:", error);
    throw error;
  }
};

export const saveTax = async (tax) => {
  const response = await axios.post(`${BASE_URL}/api/Tax/save`, tax, {
    headers: getAuthHeader(),
  });
  return response.data;
};
